import { Fragment, FunctionComponent } from 'react';
import { Switch } from 'react-router-dom';
import { DataSourceDetails } from './components/dataSourceDetails';
import { PrivateRoute } from '../router/components';
import { DataSourcesV2 } from './DataSourcesV2';
import RouteConstants from '../router/RouteConstants';
import { CreateDataSource } from './components/createDataSource';

export const DataSourcesRouter: FunctionComponent = () => (
  <Fragment>
    <Switch>
      <PrivateRoute path={RouteConstants.dataSourcesCreate} component={CreateDataSource} />
      <PrivateRoute path='/data-sources/:id' component={DataSourceDetails} />
      <PrivateRoute path='/data-sources' component={DataSourcesV2} />
    </Switch>
  </Fragment>
);
